// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Cookie from '../classes/Cookie';
import Time from '../constants/Time';

export default class AlertCloseButton extends Component {
  #alertId: string;

  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const alertId = pEl.dataset.alertId;
    if (!alertId) {
      throw new Error('The alert id is required');
    }
    this.#alertId = alertId;

    this.addEventListener(EventNames.CLICK, () => {
      Cookie.set(`alert_${this.#alertId}`, '1', Time.YEAR_IN_SECONDS);
    });
  }
}
